import { USER_STATUS } from 'utils/constants/roles';
import { ROLES } from '../../constants';
import {
  getItemOrDefaultToValue,
  getPersonName,
  getDepartmentNamesArray,
} from '../../details';
import { getDisplayRoles } from '../../helper/roles';
import { images } from 'utils/icons';

export const transformPersonnelList = ({ list, globalDepartmentList = [] }) => {
  return list.map(data => ({
    id: data.general.id,
    employeeId: getItemOrDefaultToValue(data.general, 'employeeId', '-'),
    role: getDisplayRoles(data.general),
    archived: getItemOrDefaultToValue(data.details, 'archived', false),
    deleted: getItemOrDefaultToValue(data.general, 'deleted', false),
    email: getItemOrDefaultToValue(data.general, 'email', '-'),
    emailVerified: getItemOrDefaultToValue(
      data.details.verifications,
      'emailVerified',
      false,
    ),
    name: getPersonName(data.general),
    phone:
      data.general.phoneNumber !== null
        ? `${getItemOrDefaultToValue(
            data.general.phoneNumber,
            'prefix',
          )} ${getItemOrDefaultToValue(
            data.general.phoneNumber,
            'number',
            '-',
          )}`
        : '-',
    phoneVerified: getItemOrDefaultToValue(
      data.details.verifications,
      'phoneVerified',
      false,
    ),
    departments: getDepartmentNamesArray(globalDepartmentList, data),
    services: getItemOrDefaultToValue(data.details, 'services', []),
    // qualifications: getItemOrDefaultToValue(data.details, 'qualifications', []),
    qualifications:
      data.details.qualifications != null
        ? getItemOrDefaultToValue(data.details, 'qualifications')
        : [],
    status: getItemOrDefaultToValue(
      data.operational,
      'status',
      USER_STATUS.NOT_LOGGED_IN.id,
    ),
    location:
      data.operational.location !== null
        ? getItemOrDefaultToValue(data.operational.location, 'point')
        : undefined,
    isResponder: getItemOrDefaultToValue(data.general, 'roles', []).includes(
      ROLES.RESPONDER.id,
    ),
    assignedSite:
      data.details.assignedSite.siteName !== null &&
      data.details.assignedSite.siteName !== ''
        ? getItemOrDefaultToValue(data.details.assignedSite, 'siteName', '-')
        : '-',
  }));
};

export const transformRaw = list => {
  return list.map(item => ({
    pageName: '/people/personnel',
    label: getPersonName(item.general),
    value: item,
    id: item.general.id,
    status: getItemOrDefaultToValue(item.operational, 'status'),
    qualifications:
      item.details.qualifications != null
        ? getItemOrDefaultToValue(item.details, 'qualifications')
        : [],
    services: getItemOrDefaultToValue(item.details, 'services', []),
    icon: images[item.operational.status]?.default,
  }));
};

export const transformBasicPersonnel = list => {
  return list.map(item => ({
    id: item.general.id,
    name: getPersonName(item.general),
    photoUrl: item.general.photoUrl,
    icon: images[item.operational.status]?.default,
  }));
};

export const transformUserMap = list => {
  return list.map(item => ({
    id: item.general.id,
    name: getPersonName(item.general),
  }));
};
